module.exports = __webpack_public_path__ + "img/login_R.89329adf.png";